module.exports = __webpack_public_path__ + "img/1.045a414e.jpg";